import { render, staticRenderFns } from "./configurationList.vue?vue&type=template&id=1073d956&scoped=true&"
import script from "./configurationList.vue?vue&type=script&lang=js&"
export * from "./configurationList.vue?vue&type=script&lang=js&"
import style0 from "./configurationList.vue?vue&type=style&index=0&id=1073d956&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1073d956",
  null
  
)

export default component.exports